import {tokens} from '../tokens';

export const en = {
  [tokens.common.languageChanged]: 'Language changed',
  [tokens.nav.pwm]: 'Public Works Monitor',
  [tokens.nav.account]: 'Account',
  [tokens.nav.admin]: 'Administration',
  [tokens.nav.home]: 'Home',
  [tokens.nav.notifications]: 'Notifications',
  [tokens.nav.list]: 'List',
  [tokens.nav.bidlist]: 'Solicitations',
  [tokens.nav.biddetail]: 'Solicitation Detail',
  [tokens.nav.bidnew]: 'Create New Solicitation',
  [tokens.nav.contractlist]: 'Contracts',
  [tokens.nav.contractdetail]: 'Contract Detail',
  [tokens.nav.contractnew]: 'Create New Contract',
  [tokens.nav.certificationdetail]: 'Certification',
  [tokens.nav.vendorsearch]: 'Search for Vendors',
  [tokens.nav.vendordetail]: 'Vendor Detail',
  [tokens.nav.vendorassignmentdetail]: 'Vendor Assignment Detail',
  [tokens.nav.reports]: 'Reports',
  [tokens.nav.reportdesigner]: 'Designer',
    [tokens.nav.appusers]: 'Manage Users',
    [tokens.nav.approles]: 'Role Management',
    [tokens.nav.appsettings]: 'Application Settings',
  [tokens.interface.contractType]: 'Contract Type',
  [tokens.interface.contractTypes]: 'Contract Types',
  [tokens.interface.ccaStaff]: 'Pre-Award Contract Assistant',
  [tokens.interface.csStaff]: 'Pre-Award Contract Specialist',
  [tokens.interface.add]: 'Add',
  [tokens.interface.send]: 'Send',
  [tokens.interface.active]: 'Active',
  [tokens.interface.actions]: 'Actions',
  [tokens.interface.action]: 'Action',
  [tokens.interface.confirmcancel]: 'Are you sure you want to cancel?',
  [tokens.interface.saveprogress]: 'Save Progress',
  [tokens.interface.view]: 'View',
  [tokens.interface.open]: 'Open',
  [tokens.interface.set]: 'Set',
  [tokens.interface.details]: 'Details',
  [tokens.interface.inactive]: 'In-Active',
  [tokens.interface.effective]: 'Effective',
  [tokens.interface.message]: 'Message',
  [tokens.interface.expires]: 'Expires',
  [tokens.interface.refresh]: 'Refresh',
  [tokens.interface.information]: 'Information',
  [tokens.interface.name]: 'Name',
  [tokens.interface.poundSign]: '#',
  [tokens.interface.contract]: 'Contract No.',
  [tokens.interface.generalcontractor]: 'General Contractor',
  [tokens.interface.dirregname]: 'DIR Registered Company Name',
  [tokens.interface.dbanamepreferredmessage]: 'Preferred name will take precedent over the DIR Registered Company Name',
  [tokens.interface.preferred]: 'Preferred',
  [tokens.interface.projectvendors]: 'Project Contractors',
  [tokens.interface.projectvendor]: 'Project Contractor',
  [tokens.interface.projectvendorinactivemessage]: 'Contractor has been identified as inactive due to expired/invalid DIR and/or CSLB registration',
  [tokens.interface.notifications]: 'Notifications',
  [tokens.interface.appusers]: 'Manage Users',
  [tokens.interface.cslbno]: 'CSLB #',
  [tokens.interface.created]: 'Created',
  [tokens.interface.createdate]: 'Created Date',
  [tokens.interface.date]: 'Date',
  [tokens.interface.modifications]: 'Modifications',
  [tokens.interface.instructions]: 'Instructions',
  [tokens.interface.ignore]: 'Ignore',
  [tokens.interface.ignoremessage]: 'DBA Name is clearly incorrect and we can ignore it. Common example are vendors that use their DIR registered Craft as their DBA.',
  [tokens.interface.createcertifysublist]: 'Create Certification Request',
  [tokens.interface.createcertifysublistdate]: 'Required Finish Date',
  [tokens.interface.certifysublistrequest]: 'Certify Sublist Requests',
  [tokens.interface.certifycomplete]: 'Certification Complete',
  [tokens.interface.certifylist]: 'Subcontractor List Certifications',
  [tokens.interface.certificationdetail]: 'Subcontractor List Verification and Update',
  [tokens.interface.certifyinstruction1]: 'Please review the current sub contractor list below. Click the modify button if you wish to change the assigned classifications or "deactivate"',
  [tokens.interface.certifyinstruction2]: 'To add a new sub contractor to the project, click the Add New button and search by DIR number (preferred), or by company name',
  [tokens.interface.certifyinstruction3]: 'If there are no modifications required, simply click Complete and Certify button below',
  [tokens.interface.completeandcertify]: 'Complete and Certify',
  [tokens.interface.certifyinstructionunderstand]: 'I understand these instructions',
  [tokens.interface.searchforvendor]: 'Search for Sub-Contractor', // changed 10/1 PWM Testing Check-In with Ashley, Sharon, Sean
  [tokens.interface.searchforgeneralcontractor]: 'Search for General Contractor', // changed 10/1 PWM Testing Check-In with Ashley, Sharon, Sean. Changed again on 3/27 With Ashley, Sharon, Asma.
  [tokens.interface.searchforvendorinstruction]: 'Search by DIR #, CSLB #',
  [tokens.interface.state]: 'State',
  [tokens.interface.zip]: 'Zip Code',
  [tokens.interface.city]: 'City',
  [tokens.interface.addsubtitle]: 'Add Subcontractor',
  [tokens.interface.addnewsub]: 'Add New Subcontractor',
  [tokens.interface.noresultsmessage]: 'No results, please try again',
  [tokens.interface.notfound]: 'Not found',
  [tokens.interface.select]: 'Select',
  [tokens.interface.selectclassifications]: 'Select Classifications',
  [tokens.interface.currentsublist]: 'Current Subcontractor List',
  [tokens.interface.dirno]: 'DIR #',
  [tokens.interface.id]: 'ID #',
  [tokens.interface.licno]: 'License #',
  [tokens.interface.licenses]: 'Licenses',
  [tokens.interface.dirprojectno]: 'DIR Project #',
  [tokens.interface.effective]: 'Effective',
  [tokens.interface.addate]: 'Advertisement Date',
  [tokens.interface.eststart]: 'Estimated Start',
  [tokens.interface.estfinish]: 'Estimated Finish',
  [tokens.interface.estamount]: 'Estimate Amount',
  [tokens.interface.awardamt]: 'Award Amount',
  [tokens.interface.awardsuccess]: 'Awarded Successfully',
  [tokens.interface.awardon]: 'Awarded On',
  [tokens.interface.awardthis]: 'Award This',
  [tokens.interface.awardandclose]: 'Award & Close Solicitation',
  [tokens.interface.awardandopen]: 'Award & Keep Solicitation Open',
  [tokens.interface.awardandclosemessage]: "Clicking 'Confirm' will award this RFP and CLOSE, do you wish to continue?",
  [tokens.interface.awardandopenmessage]: "Clicking 'Confirm' will award this RFP and keep the RFP OPEN for multiple contract awards, do you wish to continue?",
  [tokens.interface.backgroundrefresh]: 'information is being refreshed in the background and will be available in a few minutes.',
  [tokens.interface.boardawarddate]: 'Board Award Date',
  [tokens.interface.wagedetermination]: 'Wage Determination',
  [tokens.interface.psa]: 'PSA Project',
  [tokens.interface.projectsystem]: 'Project System',
  [tokens.interface.discardchanges]: 'Discard Changes',
  [tokens.interface.districtprojectno]: 'District Project Number/ID',
  [tokens.interface.districtprojectnohelptext]: 'Project number from originating system, Unifier, TMA, etc.',
  [tokens.interface.registeredsubs]: 'Registered Subs',
  [tokens.interface.remove]: 'Remove',
  [tokens.interface.removed]: 'Removed',
  [tokens.interface.removefrombid]: 'Remove From Bid',
  [tokens.interface.removefrombidmessage]: "Clicking 'Confirm' will remove vendor from the bid, do you wish to continue?",
  [tokens.interface.selections]: 'Selections',
  [tokens.interface.additions]: 'Additions',
  [tokens.interface.psaimpact]: 'Modifications to the list of sub contractors will be performed in the PSA Application',
  [tokens.interface.inactivatevendormessage]: 'Brief message explaining why the vendor is inactive',
  [tokens.interface.inactivatevendorinstructions]: 'The In-Activate feature is to be used when a vendor no longer has a valid DIR registration or CSLB license, but performed work when they had valid DIR or CSLB registrations.',
  [tokens.interface.save]: 'Save',
  [tokens.interface.saved]: 'Saved',
  [tokens.interface.error]: 'Error!',
  [tokens.interface.cancel]: 'Cancel',
  [tokens.interface.messageandsave]: 'Enter a brief message and click Save.',
  [tokens.interface.addassignment]: 'Add Assignment',
  [tokens.interface.modify]: 'Modify',
  [tokens.interface.unsavedwarning]: 'You have unsaved progress, are you sure?',
  [tokens.interface.modifyassignment]: 'Modify Assignment',
  [tokens.interface.removesubmessage]: 'Deactivating a vendor will only remove the vendor from the active list.  Deactivation does not delete the vendor from the project, nor will it fulfill or replace the official substitution process.',
  [tokens.interface.certifymessage]: 'Certification Requests are sent to the general contractor to modify the Project Contractor List',
  [tokens.interface.vendorname]: 'Vendor Name',
  [tokens.interface.vendor]: 'Vendor',
  [tokens.interface.dir]: 'DIR',
  [tokens.interface.cslb]: 'CSLB',
  [tokens.interface.pwcclassification]: 'PWC-100 Classifications',
  [tokens.interface.dirclassification]: 'PWC-100 Classification',
  [tokens.interface.vendorregistration]: 'Vendor Registrations',
  [tokens.interface.editclassifications]: 'Modify PWC-100 Classifications',
  [tokens.interface.bidsearch]: 'Search solicitations',
  [tokens.interface.bidno]: 'Solicitation Number',
  [tokens.interface.bidclosed]: 'Solicitation Closed',
  [tokens.interface.edit]: 'Edit',
  [tokens.interface.delete]: 'Delete',
  [tokens.interface.deleted]: 'Deleted',
  [tokens.interface.viewbid]: 'View Solicitation',
  [tokens.interface.viewcontract]: 'View Contract',
  [tokens.interface.addbidresponse]: 'Add New Bidder',
  [tokens.interface.bids]: 'Bids',
  [tokens.interface.bidamount]: 'Bid Amount',
  [tokens.interface.nonresponsivebid]: 'Non-Responsive Bid',
  [tokens.interface.editbid]: 'Edit Contractor Bid',
  [tokens.interface.replacegc]: 'Replace GC',
  [tokens.interface.marknonresponsivebid]: 'Mark Non-Responsive',
  [tokens.interface.marknonresponsivebidmessage]: 'This will mark the bid non-responsive. Do you wish to continue?',
  [tokens.interface.deletebidmessage]: 'This will delete the bid. Only use this to remove a bid added by mistake.  Do you wish to continue?',
  [tokens.interface.contractsearch]: 'Search contracts',
  [tokens.interface.confirm]: 'Confirm',
  [tokens.interface.lastverified]: 'Last Verified',
  [tokens.interface.verified]: 'Verified',
  [tokens.interface.verificationhistory]: 'Verification History',
  [tokens.interface.verificationpdf]: 'Verification PDF',
  [tokens.interface.registrations]: 'Registrations',
  [tokens.interface.activemessage]: "Vendor is active and available for use in the PWM application, and will appear in searches, reports and be available to assign for work.",
  [tokens.interface.inactivemessage]: 'Vendor is not active and is not to be used in the PWM application and will be hidden in reports.',
  [tokens.interface.activebidsearch]: 'Active Solicitations Only',
  [tokens.interface.activecontractsearch]: 'Active Contracts Only',
  [tokens.interface.contractsearchhidden]: 'Contracts hidden by filters',
  [tokens.interface.bidsearchhidden]: 'Solicitations hidden by filters',
  [tokens.interface.contactemail]: 'Contact Email',
  [tokens.interface.address]: 'Address',
  [tokens.interface.address1]: 'Address Line 1',
  [tokens.interface.address2]: 'Address Line 2',
  [tokens.interface.address3]: 'Address Line 3',
  [tokens.interface.projectassignments]: 'Contract Assignments',
  [tokens.interface.vendorsearchmessage]: "Find a vendor's contract assignments and basic information. This search is limited to vendors in PWM and does not search the DIR or CSLB systems. Use the search box below to get started.",
  [tokens.interface.vendorsearchhelptext]: 'Search by vendor name, DIR #, CSLB #, Please enter at least 3 characters',
  [tokens.interface.search]: 'Search',
  [tokens.interface.reset]: 'Reset',
  [tokens.interface.projectcount]: 'Project Count',
  [tokens.interface.project]: 'Contract',
  [tokens.interface.assignedon]: 'Assigned On',
  [tokens.interface.close]: 'Close',
  [tokens.interface.comments]: 'Comments',
  [tokens.interface.requestedon]: 'Requested On',
  [tokens.interface.requestedby]: 'Requested By',
  [tokens.interface.dbanames]: 'DBA Names',
  [tokens.interface.dbanamestitle]: "Preferred Company Name to Display",
  [tokens.interface.dirclassificationused]: 'PWC-100 Classifications in Use',
  [tokens.interface.dirclassifications]: 'PWC-100 Classifications',
  [tokens.interface.notification]: 'Notification',
  [tokens.interface.notificationdetail]: 'Notification Detail',
  [tokens.interface.completed]: 'Completed',
  [tokens.interface.done]: 'Done',
  [tokens.interface.current]: 'Current',
  [tokens.interface.completedon]: 'Completed On',
  [tokens.interface.completedby]: 'Completed By',
  [tokens.interface.viewedby]: 'Viewed By',
  [tokens.interface.on]: 'On',

};
